import { useTranslation } from 'react-i18next';

export function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden pt-24 pb-20">
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-600 via-yellow-500 to-orange-500 z-0"></div>
      <div className="absolute inset-0 bg-black/20 z-10"></div>
      
      <div className="relative z-20 container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center space-y-6">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-tight">
            {t('about.hero.title')}
          </h1>
          <p className="text-white/90 text-xl sm:text-2xl lg:text-3xl leading-relaxed max-w-4xl mx-auto font-medium">
            {t('about.hero.tagline')}
          </p>
        </div>
      </div>
    </section>
  );
}
